/* eslint-disable */
import React from "react";
import { Commodities } from '../../../controls/Commodities';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";
import { SLIDE_NUMBER } from "../constants";
import { orderBy } from "lodash";
import { HierarchyControl, HierarchyControlItem } from '../../../../basf-ui';

interface ControlItem extends HierarchyControlItem<number> {
    
}

export const FrequencyControl: React.FC = () => {
    const [controlItems, setControlItems] = React.useState<ControlItem[]>([]);

    const [frequencyValue, setFrequencyValue] = useParameter<number | null>("@frequencies");

    const [dictItems,,loading] = useDictionary(dictionaryService, "slides-frequencies-slide33", undefined);

    React.useEffect(function updateControlItems() {
        if (dictItems) {
            const sortedDictItems = orderBy(dictItems, item => item.getValue<number>("order"));
            const nextControlItems = sortedDictItems.map<ControlItem>(dictItem => ({
                id: Number(dictItem.id),
                name: (dictItem.getValue("name") as any)[9] as string,
                parent: undefined,
                disabled: false,
            }));
            setControlItems(nextControlItems);

            let selectedItem = nextControlItems.find(item => item.id === frequencyValue);
            if (selectedItem === undefined && nextControlItems[0]) {
                const firstItem = nextControlItems[0];
                setFrequencyValue(firstItem.id);
            }
        }
    }, [dictItems]);

    const handlerChange = React.useCallback((selectedId: number | undefined | null) => {
        selectedId && setFrequencyValue(selectedId);
    }, []);

    return (
        <HierarchyControl
            loading={loading}
            label="Frequency"
            value={frequencyValue}
            onChange={handlerChange}
            items={controlItems}
        />
    )
};
